/**
 * Polls a check function at regular intervals until it returns true or max attempts are reached.
 * Returns true if the condition was met, false on timeout.
 */
export async function pollUntil(
  check: () => Promise<boolean>,
  options?: { intervalMs?: number; maxAttempts?: number }
): Promise<boolean> {
  const { intervalMs = 1500, maxAttempts = 20 } = options ?? {}
  for (let i = 0; i < maxAttempts; i++) {
    await new Promise((resolve) => setTimeout(resolve, intervalMs))
    if (await check()) return true
  }
  return false
}
